const $$splitComponentImporter = () => import('/src/src/routes/_cms/cms/review/publication_requests/$publicationRequestId.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
import { defineMessage } from "react-intl";
export const Route = createFileRoute("/_cms/cms/review/publication_requests/$publicationRequestId")({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  staticData: {
    pageTitle: defineMessage({
      defaultMessage: "Review Publication Request",
      description: "Page title for CMS publication request review page"
    })
  }
});